const ProfessionalLoader = ({ text = "Processing...", subtext = "Please wait a moment" }) => {
    return (
        <div className="professional-loader-overlay">
            <div className="loader-container">
                <div className="premium-spinner mx-auto"></div>
                <div className="loader-text">{text}</div>
                <div className="loader-subtext">{subtext}</div>
                <div className="progress-bar-container mx-auto">
                    <div className="progress-bar-fill"></div>
                </div>
            </div>
        </div>
    );
};

export default ProfessionalLoader;
